module.exports = __webpack_public_path__ + "media/store-chime.29dd3710.mp3";